// Programme-CATALOG grade options (programme_grades, flat rows via
// should_serialize=false) — option value is the programme_grade id (catalog
// namespace — backs `by_programme_grade_id`). Distinct from useGradeSelect,
// the org-instance flavor (grades.id). v3 useProgrammeGradeSelect parity.
import { useList } from '@refinedev/core';
import { useMemo } from 'react';

import type { APMultiSelectOption } from '@/components/ap/form';
import { attrs, type JsonApiRow } from './jsonApi';

export const useProgrammeGradeSelect = (
  programmeId: number | string | null | undefined,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const { data, isLoading } = useList({
    resource: 'programme_grades',
    filters: [
      { field: 'should_serialize', operator: 'eq', value: false },
      { field: 'by_programme_id', operator: 'eq', value: programmeId },
    ],
    pagination: { pageSize: 25 },
    queryOptions: { enabled: enabled && programmeId !== null && programmeId !== undefined },
  });

  const options = useMemo<APMultiSelectOption[]>(
    () =>
      (data?.data ?? []).map((row: JsonApiRow) => {
        const item = attrs(row);
        return {
          value: (item.id ?? row.id) as number,
          label: String(item.label ?? item.name ?? item.id),
        };
      }),
    [data?.data]
  );

  return { options, isLoading };
};
